/** @param {boolean} isDarkMode */
export function helpIconSx(isDarkMode) {
  return { color: isDarkMode ? "#fff" : "#374151", fontSize: "1.25rem" };
}

/**
 * @param {boolean} isDarkMode
 * @param {Array<{ icon: React.ReactNode, title: string, description: string }>} items
 */
export function buildHelpFeatures(isDarkMode, items, IconComponents) {
  return items.map(({ icon: iconKey, title, description }) => {
    const Icon = IconComponents[iconKey];
    return {
      icon: Icon ? <Icon sx={helpIconSx(isDarkMode)} /> : null,
      title,
      description,
    };
  });
}
